/**
 * MLD-2013
 */
export default {
  getMinPasswordLength() {
    try {
      return window.ML.password_policy.min_characters;
    } catch (e) {
      return 12;
    }
  }
}
